import React from 'react';

const Notes: React.FC = () => {
  return (
    <div>
      <h1>Notes</h1>
      <p>This is the Notes component.</p>
    </div>
  );
};

export default Notes;
